import React from 'react';
import './style.css';

function SubscriptionSection1() {
  return (
    <div className="Subscription-Content-Container">
      <div className="Subscription-ContentContainer">
        <p className="Subscription-policy-heading">Subscription Notice</p>
        <p className="Subscription-policy-heading-content">
          When you use our services, you’re trusting us with your information.
          We understand that this is a big responsibility and we work hard to
          protect your information and put you in control.
        </p>
        <p className="Subscription-policy-content-text">
          This Subscription Policy is meant to help you understand what information
          we collect, why we collect it and how you can update, manage, export
          and delete your information.
        </p>
        <p className="Subscription-Line" />
        <p className="Subscription-policy-content-text">
          We build a range of services that help millions of people daily to
          explore and interact with the world in new ways. Our services include:
        </p>
        <ul className="Subscription-bulletPoint Subscription-policy-content-text">
          <li>
            Google apps, sites and devices, such as Search, YouTube and Google
            Home
          </li>
          <li>
            Google apps, sites and devices, such as Search, YouTube and Google
            Home
          </li>
          <li>
            Google apps, sites and devices, such as Search, YouTube and Google
            Home
          </li>
        </ul>
        <p className="Subscription-policy-content-text">
          You can use our services in a variety of ways to manage your Subscription.
          For example, you can sign up for a Google Account if you want to
          create and manage content like emails and photos, or see more relevant
          search results. And you can use many Google services when you’re
          signed out or without creating an account at all, like searching on
          Google or watching YouTube videos. You can also choose to browse the
          web in a private mode, like Chrome Incognito mode. And across our
          services, you can adjust your Subscription settings to control what we
          collect and how your information is used. To help explain things as
          clearly as possible, we’ve added examples, explanatory videos and
          definitions for key terms. And if you have any questions about this
          Subscription Policy.
        </p>
        <p className="Subscription-Line" />
        <p className="Subscription-policy-heading-content">
          We want you to understand the types of information we collect as you
          use our services
        </p>
        <p
          className="Subscription-policy-content-text"
          style={{ marginTop: '23px' }}
        >
          We collect information to provide better services to all our users –
          from figuring out basic stuff such as which language you speak, to
          more complex things like which ads you’ll find most useful, the people
          who matter most to you online or which YouTube videos you might like.
          The information Google collects, and how that information is used,
          depends on how you use our services and how you manage your Subscription
          controls. When you’re not signed in to a Google Account, we store the
          information that we collect with unique identifiers tied to the
          browser, application or device that you’re using. This allows us to do
          things like maintain your preferences across browsing sessions, such
          as your preferred language or whether to show you more relevant search
          results or ads based on your activity. When you’re signed in, we also
          collect information that we store with your Google Account, which we
          treat as personal information.
        </p>
        <p className="Subscription-Line" />
        <p className="Subscription-policy-content-text">
          Contrary to popular belief, Lorem Ipsum is not simply random text. It
          has roots in a piece of classical Latin literature from 45 BC, making
          it over 2000 years old. Richard McClintock, a Latin professor at
          Hampden-Sydney College in Virginia, looked up one of the more obscure
          Latin words, consectetur, from a Lorem Ipsum passage, and going
          through the cites of the word in classical literature, discovered the
          undoubtable source. Lorem Ipsum comes from sections 1.10.32 and
          1.10.33 of &quot;de Finibus Bonorum et Malorum&quot; (The Extremes of Good and
          Evil) by Cicero, written in 45 BC. This book is a treatise on the
          theory of ethics, very popular during the Renaissance. The first line
          of Lorem Ipsum, &quot;Lorem ipsum dolor sit amet..&quot;, comes from a line in
          section 1.10.32. The standard chunk of Lorem Ipsum used since the
          1500s is reproduced below for those interested. Sections 1.10.32 and
          1.10.33 from de Finibus Bonorum et Malorum&quot; by Cicero are also
          reproduced in their exact original form, accompanied by English
          versions from the 1914 translation by H. Rackham.
        </p>
      </div>
    </div>
  );
}

export default SubscriptionSection1;
